import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function Insights() {
  return (
    <div className="bg-[#0B0B0B] min-h-screen">
      <Navbar />
      <main className="max-w-[860px] mx-auto px-6 lg:px-10 pt-36 pb-24">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]">Insights</p>
        <h1 className="mt-4 font-display font-bold text-4xl lg:text-5xl text-white tracking-tight">
          How brands work with creator talent and paid social in 2026
        </h1>

        <div className="mt-8 space-y-6 text-white/60 font-light leading-relaxed">
          <p>
            Creator marketing has stopped being a brand-awareness line item and become a performance
            channel. The brands scaling profitably treat talent partnerships and paid social as one
            system: creators produce the raw material, media buying decides which of that material gets
            budget, and the results feed back into the next production cycle. Isolating those functions
            in different teams is the single most common reason spend plateaus.
          </p>
          <h2 className="font-display font-bold text-2xl text-white tracking-tight pt-4">Match talent to purchase intent, not follower count</h2>
          <p>
            Reach is the least predictive metric available. A mechanic-credible automotive creator with
            four million followers converts differently to a couture curator with five million, because
            their audiences buy for different reasons. We select talent on category authority,
            engagement quality and market overlap — which is why our roster is organised by
            specialisation and primary markets rather than by size.
          </p>
          <h2 className="font-display font-bold text-2xl text-white tracking-tight pt-4">Creative volume is the real constraint</h2>
          <p>
            On Meta, account performance is usually limited by how many distinct creative concepts a
            brand can test each month, not by targeting. A durable programme needs a production cadence:
            several concepts per cycle, each with hook, format and length variants, shipped fast enough
            that fatigue never sets the ceiling. That requires licensing rights negotiated up front —
            content you cannot run as paid media is content you have half-bought.
          </p>
          <h2 className="font-display font-bold text-2xl text-white tracking-tight pt-4">Measure the account, not the post</h2>
          <p>
            Judge partnerships on blended return on ad spend, cost per acquisition and contribution
            margin across the account. Post-level engagement is a diagnostic, never a target. Brands
            that report this way make faster decisions about which creators to renew, which concepts to
            scale, and where the next production budget should go.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}